import React from "react";
import { Link } from "react-router-dom";
import projectLogo from "../assets/Logo.png";

function ThankYou() {
  return (
    <main className="min-h-screen bg-slate-50 px-4 py-16">
      <div className="mx-auto max-w-xl rounded-xl bg-white p-8 text-center shadow-sm">
        <img
          src={projectLogo}
          alt="Godrej Nurture"
          className="mx-auto mb-4 h-[60px] w-auto object-contain"
        />
        <h1 className="text-3xl font-bold text-slate-900">Thank You!</h1>
        <p className="mt-3 text-base text-slate-700">
          Your form has been submitted successfully. Our team will contact you soon.
        </p>
        <Link
          to="/"
          className="mt-6 inline-block rounded-md bg-[#5d627d] px-5 py-2 text-base font-semibold text-white"
        >
          Back To Home
        </Link>
      </div>
    </main>
  );
}

export default ThankYou;
